export function parallax() {
    const $window = $(window);
    const $windowHeight = $window.height();
    const $parallax = $(".has-parallax");

    $window.on("load scroll", function () {
        let scrollTop = $window.scrollTop();
        $parallax.each(function () {
            let $this = $(this);
            let itemTop = $this.offset().top;
            let speed = ($this.data("speed") || 10) * $windowHeight / 100 * .5;

            $this.css({'transform': 'translateY(' + (scrollTop - itemTop) / speed + '%' + ')'});
        });
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/parallax.js